module.exports = __webpack_public_path__ + "img/12224_24.b244b38c.png";